import React, { useState } from "react";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import getStyled from "../../hooks/getStyled";
import { SFStack } from "../grid";
import CreateReactPortal from "../../hooks/createReactPortal";

const { styled } = getStyled();

//TODO : NEED TO ADD THIS IN THE STORY BOOK
const StyledDrawerBody = styled(SFStack)(({ theme }) => ({
  padding: theme.spacing(1),
}));

const openedMixin = (theme, width) => ({
  width,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme, width) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width,
  [theme.breakpoints.up("sm")]: {
    width,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "openWidth" && prop !== "closeWidth",
})(({ theme, open, openWidth, closeWidth }) => ({
  width: openWidth,
  height: "100%",
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme, openWidth),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme, closeWidth),
  }),
}));

const SFSideDrawer = ({
  openWidth,
  closeWidth,
  headerName,
  customMenuIcon,
  children,
  disablePortal,
  defaultOpen,
  className
}) => {
  const [menuOpen, setMenuOpen] = useState(defaultOpen);

  return CreateReactPortal(
    <Drawer
      variant="permanent"
      PaperProps={{
        sx: { position: "inherit" },
      }}
      open={menuOpen}
      openWidth={openWidth}
      closeWidth={closeWidth}
      className={className}
    >
      {menuOpen ? (
        <>
          <SFStack
            direction="row"
            alignItems="center"
            justifyContent={headerName ? "space-between" : "flex-end"}
          >
            {headerName && headerName}
            <IconButton onClick={() => setMenuOpen((prv) => !prv)}>
              {customMenuIcon ? customMenuIcon : <MenuOpenIcon />}
            </IconButton>
          </SFStack>

          <StyledDrawerBody>
            {/* simply passing the drawer state to the child component*/}
            {React.cloneElement(children, { showOnlyButtons: menuOpen })}
          </StyledDrawerBody>
        </>
      ) : (
        <IconButton onClick={() => setMenuOpen((prv) => !prv)}>
          <ChevronRightIcon />
        </IconButton>
      )}

      {/* this renders in the RoutesWrapper under the div with the sideDrawerRoot id*/}
    </Drawer>,
    document.getElementById("sideDrawerRoot"),
    disablePortal
  );
};

SFSideDrawer.defaultProps = {
  disablePortal: false,
  openWidth: 267,
  closeWidth: 57,
  defaultOpen: true,
  
};

export default SFSideDrawer;
